import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/LoginPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Login',
    props: true,
    component: Login,
  },
  {
    path: '/platform',
    name: 'Platform',
    props: true,
    component: () => import('../views/SupportPlatform.vue'),
    children: [
      {
        path: 'curadoria/silo/:siloId(\\d+)',
        redirect: (to) => ({
          name: 'ValidatePoints',
          params: { siloId: to.params.siloId as string },
          query: to.query,
        }),
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        props: true,
        component: () => import('../views/DashboardHome.vue')
      },
      {
        path: 'dashboard2',
        name: 'Dashboard2',
        props: true,
        component: () => import('../views/DashboardPlane.vue')
      },
      {
        path: 'sensor-control',
        name: 'SensorControl',
        props: true,
        component: () => import('../views/SensorControlView.vue'),
        redirect: {
          name: 'SensorsContainer'
        },
        children: [
          {
            path: 'sensors',
            name: 'SensorsContainer',
            component: () => import('../components/sensor/SensorsContainer.vue')
          }
        ]
      },
      {
        path: 'sensor-logs/:farm_pk',
        name: 'SensorLog',
        props: route => ({
          farm_pk: route.params.farm_pk,
          infoMic: route.query.infoMic,
          infoCam: route.query.infoCam,
          infoFeed: route.query.infoFeed,
          infoSense: route.query.infoSense,
          sensorId: route.query.sensorId,
          module: route.query.module
        }),
        component: () => import('../views/SensorLog.vue'),
      },
      {
        path: 'maintenance',
        name: 'Maintenance',
        props: true,
        component: () => import('../views/MaintenanceDevices.vue'),
        redirect: {
          name: 'CamMaintenance'
        },
        children: [
          {
            path: 'smartcam',
            name: 'CamMaintenance',
            component: () => import('../components/CamMaintenance.vue'),
          },
          {
            path: 'smartcamv2',
            name: 'CamMaintenanceV2',
            component: () => import('../components/CamMaintenanceV2.vue'),
          },
          {
            path: 'smartmic',
            name: 'MicMaintenance',
            component: () => import('../components/MicMaintenance.vue'),
          },
          {
            path: 'smartmicv2',
            name: 'MicMaintenanceV2',
            component: () => import('../components/MicMaintenanceV2.vue'),
          },
          {
            path: 'smartfeed',
            name: 'FeedMaintenance',
            component: () => import('../components/FeedMaintenance.vue'),
          },
          {
            path: 'smartfeedv2',
            name: 'FeedMaintenanceV2',
            component: () => import('../components/FeedMaintenanceV2.vue'),
          },
          {
            path: 'smartsensev2',
            name: 'SenseMaintenanceV2',
            component: () => import('../components/SenseMaintenanceV2.vue'),
          },
        ],
      },
      {
        path: 'sensor-status',
        name: 'SensorsStatus',
        props: true,
        component: () => import('../views/SensorsStatusReport.vue'),
        redirect: {
          name: 'SensorsStatusOverview'
        },
        children: [
          {
            path: '',
            name: 'SensorsStatusOverview',
            component: () => import('../components/sensorStatus/SensorsStatusOverview.vue'),
          },
        ],
      },
      {
        path: 'administration',
        name: 'Administration',
        props: true,
        component: () => import('../views/PecsmartAdministration.vue'),
        redirect: {
          name: 'CompaniesControl'
        },
        children: [
          {
            path: 'companies/:pk?',
            name: 'CompaniesControl',
            component: () => import('../components/Adminsitration/CompanyControl.vue')
          },
          {
            path: 'barns/:pk?',
            name: 'BarnsControl',
            component: () => import('../components/Adminsitration/BarnControl.vue')
          },
          {
            path: 'farms/:pk?',
            name: 'FarmsControl',
            component: () => import('../components/Adminsitration/FarmControl.vue')
          },
          {
            path: 'batches/:pk?',
            name: 'BatchesControl',
            component: () => import('../components/Adminsitration/BatchesControl.vue')
          },
          {
            path: 'silos/:pk?',
            name: 'SilosControl',
            component: () => import('../components/Adminsitration/SiloControl.vue')
          },
          {
            path: 'stations',
            name: 'StationsControl',
            component: () => import('../components/Adminsitration/StationControl.vue')
          },
          {
            path: 'sessions',
            name: 'SessionsControl',
            component: () => import('../components/Adminsitration/SessionControl.vue')
          },
          {
            path: 'sensors/:pk?',
            name: 'SensorsControl',
            component: () => import('../components/Adminsitration/SensorControl.vue')
          },
          {
            path: 'silo-settings/:pk?',
            name: 'SiloSettings',
            component: () => import('../components/Adminsitration/SiloSettingsControl.vue')
          },
          {
            path: 'company-settings/:pk?',
            name: 'CompanySettings',
            component: () => import('../components/Adminsitration/CompanySettingsControl.vue')
          },
          {
            path: 'smartfeed-allocation/:pk?',
            name: 'SmartFeedAllocation',
            component: () => import('../components/Adminsitration/SmartfeedAllocationControl.vue')
          },
          {
            path: 'animal-type/:pk?',
            name: 'AnimalType',
            component: () => import('../components/Adminsitration/AnimalTypeControl.vue')
          },
          {
            path: 'food/:pk?',
            name: 'Food',
            component: () => import('../components/Adminsitration/FoodControl.vue')
          },
          {
            path: 'hydrometer/:pk?',
            name: 'Hydrometer',
            component: () => import('../components/Adminsitration/HydrometerControl.vue')
          },
          {
            path: 'temperature-humidity/:pk?',
            name: 'TemperatureHumidity',
            component: () => import('../components/Adminsitration/TemperatureHumidityControl.vue')
          },
          {
            path: 'losses/:pk?',
            name: 'Losses',
            component: () => import('../components/Adminsitration/LossesControl.vue')
          },
          {
            path: 'silo-load/:pk?',
            name: 'SiloLoad',
            component: () => import('../components/Adminsitration/SiloLoadControl.vue')
          }
        ]
      },
      {
        path: 'check',
        name: 'Acquisition',
        props: true,
        component: () => import('../views/CheckLastSiloProfileView.vue'),
        redirect: {
          name: 'ValidatePoints'
        },
        children: [
          {
            path: 'siloProfile',
            name: 'AcquisitionContainer',
            component: () => import('../components/CheckSiloProfile.vue')
          },
          {
            path: 'validate/:siloId?',
            name: 'ValidatePoints',
            component: () => import('../components/Check/CheckValidateContainer.vue')
          },
          {
            path: 'activity-feed',
            name: 'CorrectionActivityFeed',
            component: () => import('../views/CorrectionActivityFeedView.vue')
          },
          {
            path: 'smartfeed_processing',
            name: 'SmartFeedReprocessing',
            component: () => import('../views/SmartFeedReprocessingView.vue')
          },
          {
            path: 'smartfeed_processing_debug',
            name: 'SmartFeedProcessingDebug',
            component: () => import('../views/SmartFeedProcessingDebugView.vue')
          },
          {
            path: 'correction-investigation',
            component: () => import('../views/CorrectionInvestigationLayout.vue'),
            redirect: { name: 'CorrectionInvestigationAudits' },
            children: [
              {
                path: 'audits',
                name: 'CorrectionInvestigationAudits',
                meta: { invTab: 'audit' },
                component: () => import('../views/CorrectionInvestigationView.vue')
              },
              {
                path: 'stats',
                name: 'CorrectionInvestigationStats',
                meta: { invTab: 'stats' },
                component: () => import('../views/CorrectionInvestigationView.vue')
              }
            ]
          },
          {
            path: 'reports',
            name: 'CorrectionReports',
            component: () => import('../views/CurationDashboardView.vue')
          }
        ]
      },
      {
        path: 'general-register',
        name: 'GeneralRegister',
        props: true,
        component: () => import('../views/RegisterControlView.vue'),
        redirect: {
          name: 'RegisterControlContainer'
        },
        children: [
          {
            path: 'fluxRegister',
            name: 'FluxRegister',
            component: () => import('../components/registerControl/FluxRegisterContainer2.vue')
          },
          {
            path: 'switch-sensor',
            name: 'SwitchSensor',
            component: () => import('../components/registerControl/SwitchSensor.vue')
          },
          {
            path: 'control',
            name: 'RegisterControlContainer',
            component: () => import('../components/registerControl/RegisterControlContainer.vue')
          },
          {
            path: 'virtual-sensors',
            name: 'VirtualSensors',
            component: () => import('../views/VirtualSensorsView.vue')
          }
        ]
      },
      {
        path: 'register',
        name: 'Registration',
        props: true,
        component: () => import('../views/RegisterInformation.vue'),
        redirect: {
          name: 'RegisterUser'
        },
        children: [
          {
            path: 'user',
            name: 'RegisterUser',
            props: true,
            component: () => import('../components/RegisterUser.vue')
          },
          {
            path: 'company',
            name: 'RegisterCompany',
            props: true,
            component: () => import('../components/RegisterCompany.vue')
          },
          {
            path: 'companySettings',
            name: 'RegisterCompanySettings',
            props: true,
            component: () => import('../components/RegisterCompanySettings.vue')
          },
          {
            path: 'farm',
            name: 'RegisterFarm',
            props: true,
            component: () => import('../components/RegisterFarm.vue')
          },
          {
            path: 'barn',
            name: 'RegisterBarn',
            props: true,
            component: () => import('../components/RegisterBarn.vue')
          },
          {
            path: 'silo',
            name: 'RegisterSilo',
            props: true,
            component: () => import('../components/RegisterSilo.vue')
          },
          {
            path: 'food',
            name: 'RegisterFood',
            props: true,
            component: () => import('../components/RegisterFood.vue')
          },
          {
            path: 'smartcam',
            name: 'RegisterSmartCam',
            props: true,
            component: () => import('../components/RegisterSmartCam.vue')
          },
          {
            path: 'smartmic',
            name: 'RegisterSmartMic',
            props: true,
            component: () => import('../components/RegisterSmartMic.vue')
          },
          {
            path: 'smartfeed',
            name: 'RegisterSmartFeed',
            props: true,
            component: () => import('../components/RegisterSmartFeed.vue')
          },
          {
            path: 'stall',
            name: 'RegisterStall',
            props: true,
            component: () => import('../components/RegisterStall.vue')
          },
          {
            path: 'batch',
            name: 'RegisterBatch',
            props: true,
            component: () => import('../components/RegisterBatch.vue')
          },
          {
            path: 'reference-weight-curve',
            name: 'RegisterReferenceWeightCurve',
            props: true,
            component: () => import('../components/RegisterReferenceWeightCurve.vue')
          },
        ]
      },
      {
        path: 'installation',
        name: 'Installation',
        props: true,
        component: () => import('../views/InstallationDevices.vue'),
        redirect: {
          name: 'InstallSmartCam'
        },
        children: [
          {
            path: 'smartcam',
            name: 'InstallSmartCam',
            component: () => import('../components/InstallSmartCam.vue'),
          },
          {
            path: 'smartmic',
            name: 'InstallSmartMic',
            component: () => import('../components/InstallSmartMic.vue'),
          },
          {
            path: 'smartfeed',
            name: 'InstallSmartFeed',
            component: () => import('../components/InstallSmartFeed.vue'),
          },
          {
            path: 'smartfeed2',
            name: 'InstallSmartFeed2',
            component: () => import('../components/installation/InstallSmartFeed2.vue'),
          },
          {
            path: 'smartfeed2-1',
            name: 'InstallSmartFeed2_1',
            component: () => import('../components/installation/InstallSmartFeed2_1.vue'),
          },
          {
            path: 'smartfeedv2',
            name: 'InstallSmartFeedV2',
            component: () => import('../components/installation/InstallSmartFeedV2.vue'),
          },
          {
            path: 'smartfeedv3',
            name: 'InstallSmartFeedV3',
            component: () => import('../components/installation/InstallSmartFeedV3.vue'),
          },
        ],
      },

      {
        path: 'installation-lite',
        name: 'InstallationLite',
        props: true,
        component: () => import('../views/InstallationLiteView.vue'),
        redirect: {
          name: 'InstallLiteSmartCam'
        },
        children: [
          {
            path: 'smartfeed',
            name: 'InstallLiteSmartFeed',
            component: () => import('../components/installation/InstallLiteSmartFeed.vue'),
          },
        ],
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('../views/NotificationsView.vue'),
        children: [
          {
            path: '',
            name: 'NotificationsDefault',
            redirect: { name: 'NotificationsControl' }
          },
          {
            path: 'settings',
            name: 'NotificationsSettings',
            component: () => import('../views/SettingsNotifications.vue')
          },
          {
            path: 'control',
            name: 'NotificationsControl',
            component: () => import('../views/NotificationsControl.vue')
          }
        ]
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
